import { Component } from 'react';
import { Link } from 'react-router-dom';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <section
          className="section shell"
          style={{ textAlign: 'center', minHeight: '50vh', display: 'grid', placeItems: 'center' }}
        >
          <div>
            <h1>Something went wrong</h1>
            <p className="lead">We're sorry — an unexpected error occurred.</p>
            <div className="button-row" style={{ justifyContent: 'center', marginTop: '1.5rem' }}>
              <Link
                to="/"
                className="button button--primary"
                onClick={() => this.setState({ hasError: false })}
              >
                Return Home
              </Link>
            </div>
          </div>
        </section>
      );
    }

    return this.props.children;
  }
}
